import { Component, OnInit } from '@angular/core';
import { SuiteService } from '../../Services/suite.service';
import { TemplateServiceService } from '../../Services/template-service.service';

import { DBFieldModel } from '../../Models/db-field-model';
import { NotifyService } from 'src/app/Services/notify.service';
import { CodeLinkageSettingsModel } from 'src/app/Models/code-linkage-settings-model';


@Component({
  selector: 'ze-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
  projectCodelinkageSettingList: DBFieldModel[] = [];
  technicalCodelinkageSettingList: DBFieldModel[] = [];
  popupOpened: string;
  projectId: string;
  organisationId: string;
  user: string;
  title: string;
  isSplitEnabled: boolean = false;
  splitByData: string = null;
  fieldLevel: number = null;
  fieldName: string = null;
  codelinkagesetting: CodeLinkageSettingsModel;
  organisation_name: string;
  isPopupVisible: boolean = false;
  selectedProjectId: string | null ='';
  projectsOptions: { id: number, name: string, codeLinkageSetting: CodeLinkageSettingsModel }[] = [];

  constructor(
    public suiteService: SuiteService,
    private templateservice: TemplateServiceService,
    private notifys: NotifyService
  ) {
    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.user = this.parseJwt(currentUser1).sub;
    this.codelinkagesetting = new CodeLinkageSettingsModel([], []);
  }

  updatingCodelinkagesettingFields(codeLinkageSetting: CodeLinkageSettingsModel) {
    this.projectCodelinkageSettingList = codeLinkageSetting.project_management_fields || [];
    this.technicalCodelinkageSettingList = codeLinkageSetting.technical_details_fields || [];
  }

  ngOnInit() {
    this.getProjectData();
    this.organisationNameAndCodelinkage_Value();
    this.selectedProjectId = '';
  }


  getProjectData() {
    this.templateservice.getAllProjectList().subscribe(
      data => {
        for (let project of data.data) {
          this.projectsOptions.push({
            id: project._id,
            name: project.name,
            codeLinkageSetting: project.code_linkage_settings || new CodeLinkageSettingsModel([], [])
          });
        }
      },
      error => {
        console.error('Error fetching project list', error);
      }
    );
  }

  organisationNameAndCodelinkage_Value() {
    this.templateservice.getOrganisationByUserName(this.user).subscribe(
      data => {
        this.organisationId = data.data._id;
        this.organisation_name = data.data.name;
        this.projectCodelinkageSettingList = data.data.code_linkage_settings.project_management_fields;
        this.technicalCodelinkageSettingList = data.data.code_linkage_settings.technical_details_fields;
      },
      error => {
        console.error('Error fetching organisation name', error);
      }
    );
  }

  parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  onProjectChange(event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    this.projectId = null;
    if (event !== null && event !== '') {
      this.projectId = event;
      const selectedProject = this.projectsOptions.find(project => project.id === event);     
      if (selectedProject.codeLinkageSetting) {
        this.updatingCodelinkagesettingFields(selectedProject.codeLinkageSetting);
      } else {
        this.projectCodelinkageSettingList = [];
        this.technicalCodelinkageSettingList = [];
      }
    } else {
      this.organisationNameAndCodelinkage_Value()
    }

  }

  deleteProject(event) {
    this.projectCodelinkageSettingList = this.projectCodelinkageSettingList.filter(item => item != event);
  }
  deleteTechnicalDetails(event) {
    this.technicalCodelinkageSettingList = this.technicalCodelinkageSettingList.filter(item => item != event);
  }

  onSubmit(formValue: DBFieldModel) {
    if (this.popupOpened === "projectManagement") {
      this.projectCodelinkageSettingList.push(formValue);
      this.closePopup()
      this.notifys.notify('success', 'Success', "Sucessfully Added");
    } else {
      this.technicalCodelinkageSettingList.push(formValue);
      this.closePopup()
      this.notifys.notify('success', 'Success', "Sucessfully Added");
    }
  }

  onSave() {
    this.codelinkagesetting.project_management_fields = this.projectCodelinkageSettingList.concat();
    this.codelinkagesetting.technical_details_fields = this.technicalCodelinkageSettingList.concat();

    if (this.projectId) {
      this.templateservice.addCodeLinkageFieldsForProject(this.projectId, this.codelinkagesetting).subscribe(
        data => {
          this.notifys.notify('success', 'Success', "Sucessfully Created");
          console.log(data);
        },
        error => {
          console.error('Error saving project code linkage settings', error);
        }
      );
    } else {
      this.templateservice.addCodeLinkageFieldsForOrg(this.organisationId, this.codelinkagesetting).subscribe(
        data => {
          this.notifys.notify('success', 'Success', "Sucessfully Created");
          this.getProjectData();
          console.log(data);
        },
        error => {
          console.error('Error saving organisation code linkage settings', error);
        }
      );
    }
  }

  openPopup(temp: string): void {
    this.isSplitEnabled = false;
    this.splitByData = null;
    this.fieldLevel = null;
    this.fieldName = null;
    if (temp == "projectManagement") {
      this.title = "Project Management";
    } else {
      this.title = "Technical Details"
    }
    this.popupOpened = temp;
    this.isPopupVisible = true;
  }

  closePopup(): void {
    this.isPopupVisible = false;
  }

}
